import React, { Fragment } from "react";
import FileViewer from "react-file-viewer";
import FileViewerError from "../../FileViewer/FileViewerError";
import Moment from "react-moment";

const ResumeItem = ({
  resume,
  download,
  setDownload,
  index,
  currentIndex,
  setAcceptApplicant,
  setDeclineApplicant,
}) => {
  return (
    <Fragment>
      {resume.imeapplicant &&
        resume.imeresume &&
        index === currentIndex &&
        !resume.declinedapplicant && (
          <div>
            <div className="applicant-info-alt">
              <div className="single-section">
                <div className="flex-only">
                  <p className="sub-section blue">Professional Summary</p>
                </div>
                <p className="summary">{resume.resume.professionalsummary}</p>
              </div>
              {resume.resume.education.length > 0 &&
                resume.resume.education.map((item) => {
                  return (
                    <div className="single-section" key={item._id}>
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years blue">Education</p>
                          <div className="app-years">
                            <p className="app-year blue">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.institution}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {resume.resume.experience.length > 0 &&
                resume.resume.experience.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years blue">Experience</p>
                          <div className="app-years">
                            <p className="app-year blue">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.employer}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
              {resume.resume.skills.length > 0 &&
                resume.resume.skills.map((item) => {
                  return (
                    <div className="single-section">
                      <div className="lower-section">
                        <div>
                          <p className="sub-section-years blue">Skills</p>
                          <div className="app-years">
                            <p className="app-year blue">
                              <Moment format="MM/DD/YYYY">{item.from}</Moment> -{" "}
                              <Moment format="MM/DD/YYYY">{item.to}</Moment>
                            </p>
                          </div>
                        </div>
                        <div className="side-info">
                          <p className="applicant-side-title">
                            {item.skillname}
                          </p>
                          <ul className="education-items">
                            {item.description.map((listitem) => {
                              return (
                                <li
                                  className="education-item"
                                  key={listitem._id}
                                >
                                  <i class="fas fa-asterisk mr-5 white fa-sm"></i>
                                  {listitem.item}
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="action-container">
              <div
                className="button-actions"
                onClick={() =>
                  setAcceptApplicant({ request: true, confirm: false })
                }
              >
                <div className="text-button">
                  <p className="text">Accept Applicant</p>
                  <button className="applicant-button-resume background-dark-black white">
                    <i className="fas fa-thumbs-up blue mx-5"></i>Accept
                  </button>
                </div>
              </div>
              <div className="feedback-container">
                <textarea
                  name="feedback"
                  className="applicant-textarea"
                  placeholder="Enter Message or Resume Feedback"
                ></textarea>
              </div>
              <div
                className="button-actions"
                onClick={() =>
                  setDeclineApplicant({ request: true, confirm: false })
                }
              >
                <div className="text-button">
                  <p className="text">Decline Applicant</p>
                  <button className="applicant-button-resume background-red">
                    <i className="fas fa-thumbs-down mx-5"></i>Decline
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      {!resume.imeresume && index === currentIndex && (
        <div>
          <div className="applicant-info-alt">
            <div className="document-applicant">
              <FileViewer
                fileType={resume.documenttype}
                filePath={`/uploads/resumeattachments/${resume.resumename}`}
                errorComponent={FileViewerError}
                onError={FileViewerError}
              />
            </div>
            <div className="create-post-button-container">
              <button
                className="create-post-button background-dark-black white"
                onClick={() => {
                  setDownload(true);
                }}
              >
                <i className="fas fa-download blue mx-5"></i>Download File
              </button>
              {download && (
                <iframe
                  title="file"
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/resume_attachments/${resume.resumename}`}
                  className="file-upload"
                ></iframe>
              )}
            </div>
          </div>
          <div className="action-container">
            <div
              className="button-actions"
              onClick={() =>
                setAcceptApplicant({ request: true, confirm: false })
              }
            >
              <div className="text-button">
                <p className="text">Accept Applicant</p>
                <button className="applicant-button-resume background-dark-black white">
                  <i className="fas fa-thumbs-up blue mx-5"></i>Accept
                </button>
              </div>
            </div>
            <div className="feedback-container">
              <textarea
                name="feedback"
                className="applicant-textarea"
                placeholder="Enter Message or Resume Feedback"
              ></textarea>
            </div>
            <div
              className="button-actions"
              onClick={() =>
                setDeclineApplicant({ request: true, confirm: false })
              }
            >
              <div className="text-button">
                <p className="text">Decline Applicant</p>
                <button className="applicant-button-resume background-red">
                  <i className="fas fa-thumbs-down mx-5"></i>Decline
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default ResumeItem;
